import React from "react";
import { ProductItemWrapperOnly } from "~/components/productItem/ProductItem";
import styles from "./OneClickOptions.module.scss";
import classnames from "classnames";

export function OneClickTextAndIconOption({ title, description, Icon, disabled, onClick, dataTestId }) {
    return (
        <OneClickOption disabled={disabled} onClick={onClick} dataTestId={dataTestId}>
            <div className={classnames(styles["text-icon-btn"], disabled && styles["text-icon-btn-disabled"])} style={{ width: "100%" }}>
                <div style={{ marginTop: "-1px" }}>{Icon && <Icon size={24} />}</div>
                <div>
                    <div className={styles["text-icon-btn-title"]}>{title}</div>
                    <div className={styles["text-icon-btn-description"]}>{description}</div>
                </div>
            </div>
        </OneClickOption>
    );
}

export function OneClickTextOption({ children, ...rest }) {
    return (
        <OneClickOption {...rest}>
            <div className={styles["one-click-text-option"]}>{children}</div>
        </OneClickOption>
    );
}

export function OneClickOption({ disabled, value, dataTestId, onClick, children }) {
    return (
        <ProductItemWrapperOnly
            className={classnames(styles["one-click-option"], disabled && styles["one-click-option-disabled"])}
            onClick={disabled ? null : () => onClick(value)}
            dataTestId={dataTestId}
        >
            {children}
        </ProductItemWrapperOnly>
    );
}

export default function OneClickOptionsWrapper(props) {
    const { children } = props;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
            }}
        >
            {children}
        </div>
    );
}
